import { useCallback, type FC } from "react";
import { type CampaignOverview } from "../types/state";
import RestrictedByTooltip from "components/restrictedByTooltip/RestrictedByTooltip";
import { ContentItemMenu } from "components/buttons/contentItemMenu/ContentItemMenu";
import { BasicLinkButton, DeleteLinkButton, EditLinkButton } from "components/buttons/linkButtons";
import { DuplicateButton } from "components/buttons/linkButtons/headerButtons/DuplicateButton";
import { faPaperPlaneTop } from "@fortawesome/pro-solid-svg-icons";

const ENTITY_TYPE = "campaign";

export interface CampaignItemMenuProps {
  item: CampaignOverview;
  onEditClick: (id: number, isDraft: boolean) => void;
  onSendTestClick: (id: number) => void;
  readonly?: boolean;
  isChecked?: boolean;
  circle?: boolean;
  outlinedEllipsis?: boolean;
  hasPermission?: boolean;
  isMobo: boolean;
  onDuplicate: (id: number) => void;
  onDelete: (id: number) => void;
}

export const CampaignItemMenu: FC<CampaignItemMenuProps> = (props) => {
  const {
    circle,
    outlinedEllipsis,
    readonly,
    isChecked,
    item,
    onEditClick,
    onDuplicate,
    onSendTestClick,
    isMobo,
    onDelete,
    hasPermission = true,
  } = props;

  const handleEdit = useCallback(() => onEditClick(item.id, item.isDraft), [onEditClick, item.id, item.isDraft]);

  const handleDuplicate = useCallback(() => onDuplicate(item.id), [onDuplicate, item.id]);

  const handleSendTest = useCallback(() => onSendTestClick(item.id), [onSendTestClick, item.id]);

  const handleDelete = useCallback(() => onDelete(item.id), [onDelete, item.id]);

  return (
    <RestrictedByTooltip hasPermission={hasPermission}>
      <ContentItemMenu
        circle={circle}
        outlinedEllipsis={outlinedEllipsis}
        isChecked={isChecked}
        readonly={readonly}
        entityType={ENTITY_TYPE}
        item={item}
        showTooltip={false}
      >
        {!item.isPurchased && <EditLinkButton onClick={handleEdit} isDisabled={item.isPurchased} />}
        <DuplicateButton purchasedSelected={false} entityName={"Campaign"} onClick={handleDuplicate} />
        {!isMobo && (
          <BasicLinkButton
            text="Send Test"
            onClick={handleSendTest}
            icon={faPaperPlaneTop}
            isDisabled={!item.hasBeenPublished}
          />
        )}
        {!item.isPurchased && <DeleteLinkButton onClick={handleDelete} isDisabled={item.isPurchased} />}
      </ContentItemMenu>
    </RestrictedByTooltip>
  );
};
